import styled, { css } from 'styled-components';
var Input = styled.input.withConfig({
  displayName: "Buttonstyles__Input",
  componentId: "sc-1st9z4q-0"
})(["position:absolute;opacity:0;left:0;z-index:-1;"]);
var Label = styled.label.withConfig({
  displayName: "Buttonstyles__Label",
  componentId: "sc-1st9z4q-1"
})(["cursor:pointer;"]);
var Button = styled.button.withConfig({
  displayName: "Buttonstyles__Button",
  componentId: "sc-1st9z4q-2"
})(["border:0;background:transparent;"]);
var Span = styled.span.withConfig({
  displayName: "Buttonstyles__Span",
  componentId: "sc-1st9z4q-3"
})(["", ""], function (props) {
  return css(["color:", ";text-decoration:underline;font-family:", ";font-weight:", ";font-size:", ";"], props.theme.color.alias.link.default.color, props.theme.font.family['label-1'], props.theme.font.weight.bold, props.theme.font.size['label-1']);
});
export { Input, Label, Button, Span };